module.exports = __webpack_public_path__ + "static/media/t1.a79fd812.png";